import { Layer } from "react-map-gl";
import { hexToHSL } from "../layer-utils";
import { useEffect, useState } from "react";
import { LayerProps } from "../explorer-display-layers";
import { HSLToHSLString, highlightTypeForGeo } from "./paint";
import { highlightPaintForGeo } from "./paint";
import useDarkMode from "use-dark-mode";

export function SecondaryHighlightLayer(props: LayerProps) {
  const { value: isDark } = useDarkMode();

  const layerHSL = hexToHSL(props.layerConfig.styles.colour ?? "#FFFFFF");
  const highlightHSL = { ...layerHSL };

  const highlightSaturationOffset = isDark ? 50 : -50;
  highlightHSL.s += highlightSaturationOffset;

  const highlightLayerPaint = props.layerConfig
    ? highlightPaintForGeo(
        HSLToHSLString(highlightHSL),
        1,
        props.layerConfig.geometry,
        2
      )
    : {};

  return (
    <Layer
      key={props.id}
      layout={{
        visibility: props.layerConfig.visible ? "visible" : "none",
      }}
      beforeId={props.beforeId ?? ""}
      id={props.id}
      type={highlightTypeForGeo(props.layer.geometry)}
      source={props.source.description}
      source-layer={props.layer.id}
      paint={highlightLayerPaint}
      //@ts-ignore
      filter={props.layerConfig.secondaryHighlightsFilter}
    />
  );
}
